import { getSupabase } from "@/lib/supabase";
import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";

export function useIsAdmin() {
  const { user } = useAuth();
  // Key the effect on the id (a stable primitive), not the user object. A
  // token refresh on tab focus produces a new user object with the same id;
  // depending on the object would re-run this effect, flip `loading`, and
  // remount the AdminRoute subtree - wiping any in-progress admin form.
  const userId = user?.id ?? null;
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getSupabase()
      .rpc("is_admin")
      .then(({ data, error }) => {
        if (cancelled) return;
        setIsAdmin(!error && data === true);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { isAdmin, loading };
}
